import { MutationTree } from 'vuex';

export const state = () => ({
  id: null,
  query: {
    where: {
      generatedAt: [],
      haveAttachment: true,
      reportType: ['DNA_360', 'NUTRIGENETIC', 'DNA_PREMIUM']
    },
    offset: 0,
    limit: 10,
    sort: 'generatedAt',
    count: true
  },
  table: {
    footer: {
      'items-per-page-options': [5, 10, 25, 50, 100],
      'show-current-page': true,
      'show-first-last-page': true,
      'page-text': '{{pageStart}}',
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['createdAt'],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      }
    },
    filter: {
      keyword: '',
      generatedAt: []
    },
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: ['generatedAt'],
      sortDesc: [true],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: true
    }
  }
});

export type DNAPDFReport = ReturnType<typeof state>;

export const mutations: MutationTree<DNAPDFReport> = {
  changeId: (state, id) => (state.id = id),
  changeQuery: (state, query) => Object.assign(state.query, query),
  changeTableFilter: (state, filter) => {
    Object.assign(state.table, { filter });
    Object.assign(state.query.where, {
      keyword: filter.keyword,
      generatedAt: filter.generatedAt
    });
  },
  changeTableOptions: (state, options) => {
    Object.assign(state.table, { options });
    Object.assign(state.table.footer, { options });
    // sort: set({}, options.sortBy[0], options.sortDesc[0] ? 'DESC' : 'ASC'),
    Object.assign(state.query, {
      limit: options.itemsPerPage,
      offset: (options.page - 1) * options.itemsPerPage,
      sort: (options.sortDesc[0] ? '' : '-') + options.sortBy[0]
    });
  }
};
